import { defineStore } from 'pinia';
import api from '@/api/teacherInfos';

export const useTeacherInfosStore = defineStore('teacherInfos', {
  state: () => ({
    unread: 0,
    loading: false,
    error: null,
  }),
  actions: {
    async refreshUnread() {
      this.loading = true;
      this.error = null;
      try {
        const data = await api.unreadCount();
        this.unread = data?.unread ?? 0;
      } catch (e) {
        this.error = e?.message || 'Fehler beim Laden';
      } finally {
        this.loading = false;
      }
    },
    setUnread(value) {
      this.unread = value;
    },
  },
});
